var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-4 mr-4",attrs:{"id":"glance","width":_vm.imageSize}},[_c('v-img',{attrs:{"contain":"","src":_vm.getImage(),"height":_vm.imageSize}}),_c('v-card-subtitle',[_vm._v(" "+_vm._s(_vm.getGlancedOptionsItem.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }